"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedTableWrapper = exports.VirtualizedRow = exports.TableWrapper = exports.TableRowWrapper = exports.TableHeaderRowWrapper = exports.TableHeaderCellWrapper = exports.TableGroupHeader = exports.TableCellWrapper = exports.Gap = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../../shared/styles");
var alignment = {
  left: 'start',
  right: 'end',
  center: 'center'
};
var sizes = {
  s: '5%',
  m: '15%',
  l: '35%'
};
var Gap = exports.Gap = _styles.spacing.xs;
var TableWrapper = exports.TableWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyled__TableWrapper",
  componentId: "sc-1ywlyez-0"
})(["display:flex;flex-flow:column nowrap;box-sizing:border-box;gap:", ";width:100%;height:100%;"], Gap);
var BaseCellWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyled__BaseCellWrapper",
  componentId: "sc-1ywlyez-1"
})(["display:flex;flex-wrap:nowrap;justify-content:", ";align-items:center;", " overflow-x:clip;white-space:nowrap;"], function (_ref) {
  var align = _ref.align;
  return alignment[align];
}, function (_ref2) {
  var fixed = _ref2.fixed,
    size = _ref2.size;
  return fixed ? (0, _styledComponents.css)(["flex:0 0 ", ";"], fixed) : size ? (0, _styledComponents.css)(["flex:1 1 ", ";"], sizes[size]) : (0, _styledComponents.css)(["flex:1 0;"]);
});
var TableCellWrapper = exports.TableCellWrapper = (0, _styledComponents.default)(BaseCellWrapper).withConfig({
  displayName: "Tablestyled__TableCellWrapper",
  componentId: "sc-1ywlyez-2"
})(["text-overflow:ellipsis;gap:", ";"], _styles.spacing.s);
var TableHeaderCellWrapper = exports.TableHeaderCellWrapper = (0, _styledComponents.default)(BaseCellWrapper).withConfig({
  displayName: "Tablestyled__TableHeaderCellWrapper",
  componentId: "sc-1ywlyez-3"
})(["min-height:16px;cursor:pointer;", " :hover{color:", ";}"], function (_ref3) {
  var isSorted = _ref3.isSorted;
  return isSorted && (0, _styledComponents.css)(["color:", ";"], _styles.colors.text.brand);
}, _styles.colors.text.brand);
var BasicRowWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyled__BasicRowWrapper",
  componentId: "sc-1ywlyez-4"
})(["display:flex;flex:auto;align-items:center;box-sizing:border-box;background-color:", ";", " border-radius:", ";padding:", ";color:", ";gap:", ";"], _styles.colors.background.primary, _styles.font.base.regular, _styles.borderRadius.s, _styles.spacing.xs, _styles.colors.text.primary, _styles.spacing.m);
var TableRowWrapper = exports.TableRowWrapper = (0, _styledComponents.default)(BasicRowWrapper).withConfig({
  displayName: "Tablestyled__TableRowWrapper",
  componentId: "sc-1ywlyez-5"
})(["border:1px solid ", ";cursor:pointer;:hover{background-color:", ";}"], function (_ref4) {
  var error = _ref4.error;
  return error ? _styles.colors.border.error.default : _styles.colors.border.primary.default;
}, function (_ref5) {
  var error = _ref5.error;
  return error ? _styles.colors.background.error : _styles.colors.border.secondary.default;
});
var TableHeaderRowWrapper = exports.TableHeaderRowWrapper = (0, _styledComponents.default)(BasicRowWrapper).withConfig({
  displayName: "Tablestyled__TableHeaderRowWrapper",
  componentId: "sc-1ywlyez-6"
})(["margin:1px;position:sticky;position:-webkit-sticky !important;z-index:2;top:0;", " color:", ";"], _styles.font.utility.overline, _styles.colors.text.secondary);
var TableGroupHeader = exports.TableGroupHeader = (0, _styledComponents.default)(BasicRowWrapper).withConfig({
  displayName: "Tablestyled__TableGroupHeader",
  componentId: "sc-1ywlyez-7"
})(["", " gap:", ";background-color:", ";border:1px solid ", ";cursor:pointer;"], _styles.font.base.bold, _styles.spacing.xs, _styles.colors.background.secondary.default, _styles.colors.border.primary.default);
var VirtualizedRow = exports.VirtualizedRow = _styledComponents.default.div.withConfig({
  displayName: "Tablestyled__VirtualizedRow",
  componentId: "sc-1ywlyez-8"
})(["padding-bottom:", ";"], Gap);
var VirtualizedTableWrapper = exports.VirtualizedTableWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyled__VirtualizedTableWrapper",
  componentId: "sc-1ywlyez-9"
})(["display:flex;flex-flow:column nowrap;flex:1 1 auto;div > div{&::-webkit-scrollbar{width:24px;height:24px;}&::-webkit-scrollbar-thumb{border-right:8px solid white;border-left:8px solid white;border-radius:10.5px;background-color:", ";}&::-webkit-scrollbar-track{border-right:8px solid white;border-left:8px solid white;border-radius:10.5px;background-color:", ";}}"], _styles.colors.background.tertiary.default, _styles.colors.background.secondary.default);